/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tall_Warm_Deer_RestInputs */

const en_tall_warm_deer_rest = /** @type {(inputs: Tall_Warm_Deer_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version name`)
};

const de_tall_warm_deer_rest = /** @type {(inputs: Tall_Warm_Deer_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versionsname`)
};

/**
* | output |
* | --- |
* | "Version name" |
*
* @param {Tall_Warm_Deer_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tall_warm_deer_rest = /** @type {((inputs?: Tall_Warm_Deer_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tall_Warm_Deer_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tall_warm_deer_rest(inputs)
	return de_tall_warm_deer_rest(inputs)
});